var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "media-bank-card" }, [
    _c("div", {
      staticClass: "media-bank-card__image",
      style: {
        "background-image": "url('" + this.data.previewPicture.link + "')",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "media-bank-card__icons" }, [
      _c(
        "button",
        {
          staticClass: "media-bank-card__icon",
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
        },
        [
          _c("z-icon", {
            attrs: {
              name: _vm.data.type.xmlId === "photo" ? "scale" : "play",
              dir: "top",
              width: "52",
              height: "52",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.data.type.xmlId === "photo" &&
      (_vm.data.photo.link || _vm.data.previewPicture.link)
        ? _c(
            "a",
            {
              staticClass: "media-bank-card__icon",
              attrs: {
                download: "",
                href: _vm.data.photo.link || _vm.data.previewPicture.link,
              },
            },
            [
              _c("z-icon", {
                attrs: {
                  name: "download",
                  dir: "top",
                  width: "32",
                  height: "32",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "media-bank-card__type" },
      [
        _c("z-icon", {
          attrs: {
            name: _vm.data.type.xmlId,
            dir: "top",
            width: "32",
            height: "32",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }